/**
 * Keys should match ISO country code
 */
const COUNTRY_DATE_FORMAT = {
  default: {
    default: "MM/DD/YYYY"
  },
  MX: {
    default: "DD/MM/YYYY"
  }
};

export { COUNTRY_DATE_FORMAT };
